<template>
  <div :class="b()" :style="styleSizeName" @click="handleClick">
    <img
      :style="[styleImgName, styleSizeName]"
      :src="dataChart.value"
      :class="b({ rotate: rotate })"
      draggable="false"
    />
  </div>
</template>

<script>
import init from '@/mixins/chart';
export default {
  name: 'img2',
  mixins: [init],
  computed: {
    styleImgName() {
      return Object.assign(
        (() => {
          if (this.rotate) {
            return {
              animationDuration: this.duration / 1000 + 's'
            };
          }
          return {};
        })(),
        {
          opacity: this.option.opacity || 1
        }
      );
    },
    duration() {
      return this.option.duration || 3000;
    },
    rotate() {
      return this.option.rotate;
    }
  },
  methods: {
    handleClick() {
      this.clickFormatter &&
        this.clickFormatter({
          data: this.dataChart
        });
      this.imgClick();
    }
  }
};
</script>
